import React from "react";

import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';

import { useTheme } from '@mui/material/styles';

function InventoryScanIcon({ color: customColor, isActive }) {
    const theme = useTheme();

    const color = isActive ? '#fff' : (customColor || theme.palette.icons.color);

    return (
        <DocumentScannerIcon style={{color: color}} />
    );
}

export default InventoryScanIcon;
